import { render, staticRenderFns } from "./MasterTemplate.vue?vue&type=template&id=35fec29e&scoped=true"
import script from "./MasterTemplate.vue?vue&type=script&lang=js"
export * from "./MasterTemplate.vue?vue&type=script&lang=js"
import style0 from "./MasterTemplate.vue?vue&type=style&index=0&id=35fec29e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fec29e",
  null
  
)

export default component.exports
import {QSpace,QDialog} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QSpace,QDialog})
